import { Component, OnInit, Input, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";
import { Step } from "../../services/steps/step";
import { PATH_STEP_5 } from "../../app-routing.constants";

const isNavigationEndEvent = (event: any): event is NavigationEnd => {
    return event instanceof NavigationEnd;
};

@Component({
    selector: "ig-step",
    templateUrl: "./step.component.html",
    styleUrls: ["./step.component.scss"],
})
export class StepComponent implements OnInit {
    @Input()
    public index: number;

    @Input()
    public step: Step;

    @Input()
    public steps: Step[];

    /**
     * Adds navigation to the circles
     *
     * This can also be done using the routerLink directive, but since we're
     * already in an iframe we can just forget about doing anything with
     * accessibility.
     *
     * @param $event
     * @todo Prevent navigation to steps that aren't available yet by setting
     *   RouteGuards on all routes.
     */
    @HostListener("click", ["$event"])
    public onClick($event: MouseEvent) {
        $event.preventDefault();
        $event.stopPropagation();

        if (this.step.isCompleted) {
            this.router.navigate([this.step.path], { replaceUrl: true });
        }
    }

    constructor(private router: Router) {
        //
    }

    public get currentPath() {
        const a = document.createElement("a");
        a.href = this.router.url;

        return a.pathname;
    }

    public checkIsActive() {
        this.step.isActive = this.currentPath === this.step.path;
    }

    public checkIsComplete() {
        if (this.currentPath === this.step.path) {
            this.steps.forEach((step, index) => {
                step.isCompleted = this.index > index;
            });
        } else if (this.currentPath === `/${PATH_STEP_5}`) {
            this.steps.forEach(step => {
                step.isCompleted = true;
            });
        }
    }

    ngOnInit() {
        this.watchRouteChanges();
        this.checkIsActive();
        this.checkIsComplete();
    }

    /**
     * Watches for route changes
     *
     * Checks if the current route matches the pathname of each step. If the
     * route matches then this step is automatically set as the active one.
     *
     * @todo Check if the step is complete to set the `isCompleted` property.
     */
    public watchRouteChanges() {
        this.router.events
            .pipe(filter(isNavigationEndEvent))
            .subscribe(event => {
                this.checkIsActive();
                this.checkIsComplete();
            });
    }
}
